<template>
  <div class="m-0 dbozone-font body">
    <div class="col-12 justify-content-center d-flex flex-row header-dinogems">
      <div class="px-3 col-3 p-0">
        <div class="heading-dinogems">{{ $t("result.round") }}</div>
        <div class="text-subhead-dinogems">{{ data.roundId }}</div>
      </div>
      <div class="px-3 col-3">
        <div class="heading-dinogems">
          {{ $t("result.bet") + `${currency}` }}
        </div>
        <div class="text-subhead-dinogems">
          {{ (data.count === 0
            ? data.bet
            : data.detail.summary[data.count].bet.amount) | currencyFormatter }}
        </div>
      </div>
      <div class="px-3 col-3">
        <div class="heading-dinogems">
          {{ $t("result.winlose") + `${currency}` }}
        </div>
        <div class="text-subhead-dinogems">
          {{ (winlose) | currencyFormatter }}
        </div>
      </div>
      <div class="px-3 col-3">
        <div class="heading-dinogems">
          {{ $t("result.balance") + `${currency}` }}
        </div>
        <div class="text-subhead-dinogems">
          {{ (balance) | currencyFormatter }}
        </div>
      </div>
    </div>
    <div class="content-result-dinogems pt-3">
      <div class="text-games-dinogems">{{ "Dino Gems" }}</div>
      <div class="text-subgame-dinogems">{{ $t("dinogems.name") }}</div>
      <div class="text-date mb-1">{{ data.timestamp  }}</div>
      <div class="col-12 justify-content-center d-flex flex-row p-0 align-items-center" style="margin-top: 40px">
        <div class="col-1 d-flex align-items-center justify-content-center arrow-position"
          style="color: white; z-index: 1">
          <i v-if="state === 'FREESPIN' || state === 'FREERESPIN' || state === 'RESPIN' || state === 'SETUPFREESPIN'"
            class="fas fa-caret-left arrow-side-dinogems" @click="delCount()" />
        </div>

        <div class="col-10 d-flex flex-column align-items-center">
          <div class="d-flex flex-row justify-content-center">
            <img v-if="winnings.length > 0" class="d-flex col-12 mb-4"
              :src="require(`../../assets/resultGame/dinogems/win.png`)" alt="" />
            <img v-else-if="state === 'RESPIN' || state === 'FREERESPIN' || state === 'SETUPFREESPIN'"
              class="d-flex col-12 mb-4 lose" :src="require(`../../assets/resultGame/dinogems/lose.png`)" alt="" />
            <img v-else class="d-flex col-12 mb-4" :src="require(`../../assets/resultGame/dinogems/lose.png`)" alt="" />
          </div>
          <div class="d-flex flex-row justify-content-center">
            <img v-if="winnings.length > 0 && (state === 'SPIN' || state === 'RESPIN') && this.spinRound < 8"
              class="d-flex col-12 mb-4" :src="require(`../../assets/resultGame/dinogems/stack_${this.spinRound}.png`)"
              alt="" />
            <img v-else-if="this.spinRound > 7" class="d-flex col-12 mb-4"
              :src="require(`../../assets/resultGame/dinogems/stack_7.png`)" alt="" />
            <img v-else-if="this.win === 0 && (state !== 'FREERESPIN' && state !== 'SETUPFREESPIN')"
              class="d-flex col-12 mb-4"
              :src="require(`../../assets/resultGame/dinogems/stack_${this.spinRound - 1}.png`)" alt="" />
            <img v-else class="d-flex col-12 mb-4" :src="require(`../../assets/resultGame/dinogems/stack_0.png`)"
              alt="" />
          </div>
          <div>
            <div v-if="state === 'SPIN' || state === 'RESPIN'" class="table-dinogems pt-2"></div>
            <div v-else class="table-dinogems-free pt-2"></div>
            <div style="transform: translate(0px, 32px);">
              <div class="d-flex flex-row slot-container p-2">
                <div class="d-flex flex-column">
                  <div v-for="(reel, index) in this.reels[0]" :key="index">
                    <div style=" position: relative;text-align: center; ">
                      <img class="icon-symbol-dinogems"
                        :src="require(`../../assets/resultGame/dinogems/symbol_${reel}.png`)" alt="" />
                    </div>
                  </div>
                </div>
                <div class="d-flex flex-column">
                  <div v-for="(reel, index) in this.reels[1]" :key="index">
                    <div style=" position: relative;text-align: center; ">
                      <img class="icon-symbol-dinogems"
                        :src="require(`../../assets/resultGame/dinogems/symbol_${reel}.png`)" alt="" />
                    </div>
                  </div>
                </div>
                <div class="d-flex flex-column">
                  <div v-for="(reel, index) in this.reels[2]" :key="index">
                    <div style=" position: relative;text-align: center; ">
                      <img class="icon-symbol-dinogems"
                        :src="require(`../../assets/resultGame/dinogems/symbol_${reel}.png`)" alt="" />
                    </div>
                  </div>
                </div>
                <div class="d-flex flex-column">
                  <div v-for="(reel, index) in this.reels[3]" :key="index">
                    <div style=" position: relative;text-align: center; ">
                      <img class="icon-symbol-dinogems"
                        :src="require(`../../assets/resultGame/dinogems/symbol_${reel}.png`)" alt="" />
                    </div>
                  </div>
                </div>
                <div class="d-flex flex-column">
                  <div class="d-flex flex-column">
                    <div v-for="(reel, index) in this.reels[4]" :key="index">
                      <div style=" position: relative;text-align: center; ">
                        <img class="icon-symbol-dinogems"
                          :src="require(`../../assets/resultGame/dinogems/symbol_${reel}.png`)" alt="" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-1 d-flex align-items-center justify-content-center arrow-position">
          <i v-if="!isEndRound" class="fas fa-caret-right arrow-side-dinogems" @click="addCount()"></i>
        </div>
      </div>

      <div class="text-center pt-5 text-games-dinogems">
        <h1 v-if="state === 'FREESPIN'"> FREESPIN {{ data.count + 1 }}/{{ data.detail.summary.length }}
        </h1>
        <h1 v-else-if="state === 'FREERESPIN'"> FREESPIN {{ data.count + 1 }}/{{ data.detail.summary.length
          }} (RESPIN) </h1>
        <h1 v-else-if="state === 'SPIN'"> SPIN {{ data.count + 1 }}/{{ data.detail.summary.length }} </h1>
        <h1 v-else-if="state === 'RESPIN'"> RESPIN {{ data.count + 1 }}/{{ data.detail.summary.length }} </h1>
        <h1 v-else-if="state === 'SETUPFREESPIN'"> MYSTERY CHOICE </h1>
      </div>
      <div v-if="data.detail.featureBuy" class="text-subgame-dinogems"> Feature Buy </div>
      <div v-if="state === 'FREESPIN' || state === 'FREERESPIN'" class="col-12 justify-content-center d-flex flex-row">
        <h1 class="my-1 green">{{ $t("dinogems.multiplier.title") }} x{{ this.multiplier }}</h1>
      </div>
      <div v-if="winnings.length > 0 || state === 'FREERESPIN' && (nextState === 'FREESPIN' || nextState === '-')"
        class="col-12 justify-content-center d-flex flex-row">
        <hr class="line col-3" />
        <div class="text-detail align-items-center d-flex px-3"> {{ $t("result.detail") }} </div>
        <hr class="line col-3" />
      </div>
      <div class="col-12 justify-content-center d-flex flex-row">
        <div
          v-if="state === 'FREERESPIN' && (nextState === 'FREESPIN' || nextState === '-') || state === 'RESPIN' && (nextState === 'FREESPIN' || nextState === '-')"
          class="col-12 multiplier-box-dinogems align-items-center">
          <h1 class="my-1 green">{{ $t("result.nowin") }}</h1>
        </div>
        <div v-if="state === 'SETUPFREESPIN'" class="col-12 multiplier-box-dinogems align-items-center">
          <h1 class="my-1 green">{{ $t("dinogems.multiplier.title") }} x{{ multiplier }}</h1>
          <h1 class="my-1 green">{{ this.data.detail.freeSpin.remain }} {{ $t("result.freespin") }} </h1>
        </div>
      </div>
      <div v-if="winnings && winnings.length > 0" class="col-12 justify-content-start d-flex flex-row">
        <div class=" bet-box-dinogems p-2 px-3 justify-content-start align-items-center container win-container">
          <div class="bet-wrapper justify-content-between item d-flex col-12" v-for="(detail, index) in winnings"
            :key="index">
            <div class="d-flex flex-row">
              <img class="icon-detail-dinogems"
                :src="require(`../../assets/resultGame/dinogems/symbol_${detail.symbol}.png`)" alt="" />
              <div class="d-flex text-win align-items-center justify-content-center">
                <p class="my-1 green">{{ ` ${detail.row} ` + $t("result.kind") }}</p>
              </div>
            </div>
            <div class="d-flex text-win justify-content-center align-items-center px-3">
              <p class="my-1 green"> {{ currency }} {{ detail.amount | currencyFormatter }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import utils from "../../services/utils";
export default {
  name: "result-dinogems",
  props: {
    data: Object,
    page: Number,
    isback: Boolean
  },
  data() {
    return {
      headerHeight: null,
      dateTimeFormatter: function formatter(date) {
        return utils.dateTimeFormatter(date);
      },
      tokenData: utils.getTokenData(this.$route.query.t)
      ,
      date: "",
      time: "",
      currency: this.data.currency ? this.data.currency : "THB",
      ratecurrency: this.data.rateCurrency ? this.data.rateCurrency : 1,
      multiplierReel: this.data.detail.multiplierReels ? this.data.detail.multiplierReels : null,
      state: "SPIN",
      multiplier: 0,
      reels: [],
      winnings: [],
      isEndRound: false,
      pages: 0
    };
  },
  async created() {
    if (this.isback) {
      this.data.count = this.data.detail.summary.length - 1;
      await this.mapSymbol(this.data.detail.summary[this.data.count]);
    }
    else {
      this.data.count = 0;
      await this.mapSymbol(this.data.detail.summary[this.data.count]);
    }
  },
  methods: {
    onResize() {
      this.headerHeight = document.getElementsByClassName(
        "header-dinogems"
      )[0].offsetHeight;
    },
    async mapSymbol(result) {
      if (!this.currency.includes("(")) {
        this.currency = this.tokenData.isSymb === false ? '' : `(${this.currency})`;
      }
      this.state = result.state;
      this.nextState = result.nextState;
      this.reels = result.reels;
      this.spinRound = result.spinRound;
      this.win = result.win;
      if (this.state === 'SPIN' || this.state === 'RESPIN')
        this.multiplier = result.multiplier;
      else
        this.multiplier = result.multiplier;

      if (result.winnings === undefined)
        this.winnings = [];
      else
        this.winnings = result.winnings;


      this.isEndRound = result.isEndRound;
      this.winlose = result.win;
      this.bet = result.bet;
      this.balance = result.balance;
      this.winnings = result.winnings;

      if (result.isCoin) this.currency = 'AMS';
    },
    async addCount() {
      this.data.count += 1;
      if (this.data.count > this.data.detail.summary.length - 1) {
        this.pages += 1;
        this.$emit('fetchResult', this.page + 1)
      } else {
        await this.mapSymbol(this.data.detail.summary[this.data.count]);
      }
    },
    async delCount() {
      this.data.count -= 1;
      if (this.page > 0) {
        this.pages -= 1;
        this.$emit('fetchResult', this.page - 1, true)
      } else {
        await this.mapSymbol(this.data.detail.summary[this.data.count]);
      }
    },
  },
};
</script>
<style scoped>
body {
  font-family: "Prompt", sans-serif;
  background-color: #292933;
  margin: 0;
}

.lose {
  visibility: hidden;
}

.arrow-position {
  transform: translate(0px, 158px);
}

.win-container {
  height: fit-content;
}

.wheel-wrapper {
  position: absolute;
  width: 570px;
  height: 100%;
  top: 7px;
}

.text-win {
  height: x;
}

.fg-image {
  width: 570px;
}

.multiplier-wrapper {
  top: -95px;
  z-index: 6;
  height: 134px;
  overflow: hidden;
}

.multiplier-image {
  width: 90%;
  transform: scale(0.9);
  margin-left: 21px;
}

.icon-detail-dinogems {
  width: 140px;
  height: 144px;
  padding: 4px;
}

.icon-bonus-dinogems {
  width: 100px;
  height: 100px;
  padding: 10px;
}

.arrow {
  color: #cac095;
  text-align: center;
}

.arrow-side-dinogems {
  cursor: pointer;
  color: #ffff;
  text-align: center;
  font-size: 90px;
}

.arrow-side-monster:hover {
  color: #06112d;
  text-align: center;
  /* font-size: 90px; */
}

.bet-box-dinogems {
  /* background: #0c161f; */
  border-radius: 10px;
  min-height: 200px;
  max-height: 300px;
  /* overflow-y: scroll; */
  min-width: 100px;
  max-width: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 800px;
}

.multiplier-box-dinogems {
  /* background: #0c161f; */
  border-radius: 10px;
  min-height: 50px;
  max-height: 100px;
  overflow-y: scroll;
  min-width: 100px;
  max-width: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 800px;
}

.bonus-box-dinogems {
  background: #0c161f;
  border-radius: 10px;
  min-height: 150px;
  max-height: 300px;
  overflow-y: scroll;
  min-width: 100px;
  max-width: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.bet-wrapper-dinogems .item {
  color: #fff;
  /* background: #06112d; */
  line-height: 1;
  border-radius: 10px;
  /* border: 1.5px solid #cac095; */
}

.bet-box-dinogems .bet-wrapper-dinogems:not(:first-child) .item {
  margin-top: 10px;
  /* width: 800px; */
}

.bet-wrapper-dinogems,
.result-wrapper {
  font-size: 35px;
  /* width: 800px; */
}

.header-dinogems {
  background: #C0151D;
  padding: 10px 0;
  flex-wrap: wrap;
}

.header-dinogems>div {
  flex-grow: 1;
  font-size: 20px;
  line-height: 1.1;
}

.heading-dinogems {
  color: #fff;
  text-align: center;
}

.content-result-dinogems {
  background: #1E0D24;
  height: 250vh;
  width: 100%;
  background-size: cover;
  background-attachment: scroll;
  background-repeat: no-repeat;
}

.title>.heading-dinogems {
  font-size: 40px;
  font-weight: bold;
  margin-bottom: 0;
}

.title>.sub {
  font-size: 30px;
  line-height: 1;
}

.text-games-dinogems {
  color: #ffffff;
  font-size: 25px;
  text-align: center;
}

.text-subhead-dinogems {
  font-size: px;
  color: #fff;
  text-align: center;
}

.text-subgame-dinogems {
  font-size: 20px;
  color: #ffd500;
  text-align: center;
}

.text-date {
  font-size: px;
  color: #fff;
  text-align: center;
}

.text-detail {
  font-size: 20px;
  color: #fff;
  text-align: center;
}

.icon-symbol-dinogems {
  position: relative;
  width: 100%;
  /* padding: 5%; */
}

.bet-box-dinogems {
  min-width: 600px;
  max-width: auto;
}

.win-box {
  width: 760px;
}

.icon-symbol {
  position: absolute;
  transform: translate(-108px, 0px);
}

.icon-symbol.-level1 {
  width: 109px;
  height: 89px;
}

.icon-symbol.-level2 {
  width: 109px;
  height: 176px;
}

.icon-symbol.-level3 {
  width: 109px;
  height: 266px;
}

.icon-symbol.-level4 {
  width: 112px;
  height: 352px;
}

.table-dinogems {
  background: url("~@/assets/resultGame/dinogems/frame_history.png") no-repeat;
  z-index: 5;
  background-size: 649px 535px;
  width: 649px;
  height: 535px;
  border-radius: 5px;
  font-size: 30px;
  text-align: center;
  margin-top: 150px;
  position: absolute;
  z-index: 0;
  transform: translate(5px, -117px);
}

.table-dinogems-free {
  background: url("~@/assets/resultGame/dinogems/frame_history_freespins.png") no-repeat;
  z-index: 5;
  background-size: 649px 535px;
  width: 649px;
  height: 535px;
  border-radius: 5px;
  font-size: 30px;
  text-align: center;
  margin-top: 150px;
  position: absolute;
  z-index: 0;
  transform: translate(5px, -117px);
}

.slot-container {
  position: relative;
  align-items: center;
  justify-content: center;
  transform: scale(0.88, 0.88);
}

.multiplier-container {
  width: 100%;
}

.top-reel {
  display: flex;
  flex-direction: row;
  position: relative;
}

.table-pos {
  transform: translate(0px, -7px);
}

.text-multiplier {
  width: 689px;
  text-align: center;
  color: #fff;
  font-size: 66px;
  display: flex;
  align-items: center;
  justify-content: center;
  transform: translate(0px, 26px);
  height: 121px;
}

.multiplier {
  z-index: 1;
  transform: translate(0px, 16px);
}

.win-stack {
  width: 100%;
}

@media screen and (min-width: 1060px) {
  .wheel-wrapper {
    position: absolute;
    width: 500px;
    height: 100%;
    top: 7px;
  }

  .multiplier-wrapper {
    top: -115px;
    z-index: 6;
    height: 134px;
    overflow: hidden;
  }

  .fg-image {
    width: 570px;
    margin-left: -34px;
  }

  .multiplier-image {
    width: 90%;
    transform: scale(1);
    margin-left: 21px;
  }

  .d-md-spec-flex {
    display: flex;
  }

  .result-wrapper .symbol {
    width: 140px;
  }

  .bet-wrapper-dinogems,
  .result-wrapper {
    font-size: 33px;
    /* width: 800px; */
  }

  .icon-symbol {
    position: absolute;
    transform: translate(-127px, 0px);
  }

  .icon-symbol.-level1 {
    width: 127px;
    height: 105px;
  }

  .icon-symbol.-level2 {
    width: 126px;
    height: 210px;
  }

  .icon-symbol.-level3 {
    width: 127px;
    height: 315px;
  }

  .icon-symbol.-level4 {
    width: 126px;
    height: 419px;
  }

  .arrow-position {
    transform: translate(0px, 150px);
  }
}

@media screen and (max-width: 1030px) {
  .table-dinogems {
    background-size: 649px 535px;
    width: 649px;
    height: 535px;
    transform: translate(0px, -114px);
  }

  .table-dinogems-free {
    background-size: 649px 535px;
    width: 649px;
    height: 535px;
    transform: translate(0px, -114px);
  }

  .wheel-wrapper {
    position: absolute;
    width: 500px;
    height: 100%;
    top: 7px;
  }

  .fg-image {
    width: 500px;
  }

  .multiplier-wrapper {
    top: -107px;
    z-index: 6;
    height: 134px;
    overflow: hidden;
  }

  .multiplier-image {
    width: 90%;
    transform: scale(0.9);
    margin-left: 21px;
  }

  .wrapper {
    flex-direction: column;
  }

  .wrapper>div:first-child {
    order: 2;
  }

  .wrapper>div:last-child {
    order: 1;
  }

  .arrow-side-monster {
    font-size: 60px;
  }

  .bet-box-dinogems {
    min-width: 580px;
    max-width: auto;
    height: 100%;
  }

  .result-wrapper {
    font-size: 35px;
    width: 800px;
  }

  .win-box {
    width: 689px;
  }

  .icon-symbol {
    position: absolute;
    transform: translate(-126px, 0px);
  }

  .icon-symbol.-level1 {
    width: 127px;
    height: 104px;
  }

  .icon-symbol.-level2 {
    width: 126px;
    height: 209px;
  }

  .icon-symbol.-level3 {
    width: 127px;
    height: 314px;
  }

  .icon-symbol.-level4 {
    width: 127px;
    height: 419px;
  }
}

.line {
  background-color: #fff;
  height: 2px;
  width: 100%;
}

.red {
  color: #ff0000;
}

.green {
  color: #fff;
  font-size: 35px;
}

.win-box {
  width: 689px;
}

@media screen and (max-width: 800px) {
  .table-dinogems {
    background-size: 100% 100%;
    width: 94%;
    height: 65%;
    margin-bottom: 1%;
    transform: translate(0px, -115px);
  }

  .table-dinogems-free {
    background-size: 100% 100%;
    width: 94%;
    height: 65%;
    margin-bottom: 1%;
    transform: translate(0px, -115px);
  }

  .top-reel {
    width: 67%;
    transform: translate(111px, 0px);
  }

  .icon-symbol {
    position: absolute;
    transform: translate(-111px, 0px);
  }

  .icon-symbol.-level1 {
    width: 110px;
    height: 92px;
  }

  .icon-symbol.-level2 {
    width: 111px;
    height: 183px;
  }

  .icon-symbol.-level3 {
    width: 111px;
    height: 275px;
  }

  .icon-symbol.-level4 {
    width: 111px;
    height: 367px;
  }
}

@media screen and (max-width: 770px) {
  .heading-dinogems {
    font-size: 18px;
  }

  .table-dinogems {
    background-size: 100% 100%;
    width: 94%;
    height: 70%;
    margin-bottom: 1%;
    transform: translate(0px, -115px);
  }

  .table-dinogems-free {
    background-size: 100% 100%;
    width: 94%;
    height: 70%;
    margin-bottom: 1%;
    transform: translate(0px, -115px);
  }

  .fg-image {
    width: 470px;
  }

  .wheel-wrapper {
    position: absolute;
    width: 470px;
    height: 100%;
    top: 7px;
  }

  .multiplier-wrapper {
    top: -95px;
    z-index: 6;
    height: 134px;
    overflow: hidden;
  }

  .multiplier-image {
    width: 90%;
    transform: scale(0.9);
    margin-left: 21px;
  }

  .text-subhead-dinogems {
    font-size: 18px;
  }

  .arrow-side-monster {
    font-size: 30px;
  }

  .bet-box-dinogems {
    min-width: 430px;
    max-width: auto;
    height: 100%;
  }

  .text-date {
    font-size: 20px;
    color: #fff;
    text-align: center;
  }

  .top-reel {
    width: 67%;
    transform: translate(104px, 0px);
  }

  .win-box {
    width: 689px;
  }

  .icon-symbol {
    position: absolute;
    transform: translate(-107px, 0px);
  }

  .icon-symbol.-level1 {
    width: 107px;
    height: 89px;
  }

  .icon-symbol.-level2 {
    width: 107px;
    height: 177px;
  }

  .icon-symbol.-level3 {
    width: 107px;
    height: 264px;
  }

  .icon-symbol.-level4 {
    width: 106px;
    height: 352px;
  }

  .multiplier-container {
    width: 80%;
  }

  .green {
    font-size: 40px;
  }

  .win-stack {
    width: 96%;
  }

  .arrow-position {
    transform: translate(0px, 151px);
  }
}

@media screen and (max-width: 600px) {
  .table-dinogems {
    background-size: 100% 100%;
    width: 94%;
    height: 65%;
    margin-bottom: 1%;
    transform: translate(0px, -115px);
  }

  .table-dinogems-free {
    background-size: 100% 100%;
    width: 94%;
    height: 65%;
    margin-bottom: 1%;
    transform: translate(0px, -115px);
  }

  .top-reel {
    width: 67%;
    transform: translate(82px, 0px);
  }

  .icon-symbol {
    position: absolute;
    transform: translate(-83px, 0px);
  }

  .icon-symbol.-level1 {
    width: 83px;
    height: 70px;
  }

  .icon-symbol.-level2 {
    width: 83px;
    height: 138px;
  }

  .icon-symbol.-level3 {
    width: 83px;
    height: 207px;
  }

  .icon-symbol.-level4 {
    width: 83px;
    height: 275px;
  }

  .arrow-position {
    transform: translate(0px, 130px);
  }
}

@media screen and (max-width: 480px) {
  .table-dinogems {
    background-size: 100% 100%;
    width: 90%;
    height: 60%;
    margin-bottom: 1%;
    transform: translate(0px, -115px);
  }

  .table-dinogems-free {
    background-size: 100% 100%;
    width: 90%;
    height: 60%;
    margin-bottom: 1%;
    transform: translate(0px, -115px);
  }

  .wheel-wrapper {
    position: absolute;
    width: 500px;
    height: 100%;
    top: 7px;
  }

  .multiplier-wrapper {
    top: -95px;
    z-index: 6;
    height: 134px;
    overflow: hidden;
  }

  .fg-image {
    width: 230px;
    height: 189px;
    margin-left: 135px;
    margin-top: -9px;
  }

  .multiplier-image {
    width: 90%;
    transform: scale(0.4);
    margin-left: 21px;
  }

  .header-dinogems>div {
    flex-grow: 0;
    width: 25%;
  }

  .heading-dinogems {
    font-size: 12px;
  }

  .table-dinogems {
    background-size: 100% 100%;
    width: 92%;
    height: 59%;
    transform: translate(0px, -109px);
  }

  .text-subhead-dinogems {
    font-size: 14px;
  }

  .bet-box-dinogems {
    min-width: 230px;
    max-width: auto;
    height: 100%;
  }

  .bonus-box-dinogems {
    min-width: 230px;
    max-width: auto;
    height: 150px;
  }

  .bet-wrapper-dinogems,
  .result-wrapper {
    font-size: 20px;
  }

  .icon-detail-dinogems {
    width: 33%;
    height: 88%;
  }

  .icon-bonus-dinogems {
    width: 60px;
    height: 60px;
  }

  .top-reel {
    width: 67%;
    transform: translate(62px, 0px);
  }

  .icon-symbol {
    position: absolute;
    transform: translate(-63px, 0px);
  }

  .icon-symbol.-level1 {
    width: 63px;
    height: 52px;
  }

  .icon-symbol.-level2 {
    width: 63px;
    height: 104px;
  }

  .icon-symbol.-level3 {
    width: 63px;
    height: 155px;
  }

  .icon-symbol.-level4 {
    width: 63px;
    height: 207px;
  }

  .green {
    font-size: 18px;
  }

  .text-win {
    height: 57px;
  }

  .arrow-position {
    transform: translate(0px, 111px);
  }
}

@media screen and (max-width: 550px) {
  .fg-image {
    width: 390px;
  }

  .wheel-wrapper {
    width: 396px;
  }

  .container {
    padding-bottom: 67px;
  }

  .win-box {
    width: 760px;
  }

  .green {
    font-size: 19px;
  }
}

.multiplier-text {
  font-size: 8vw;
  position: absolute;
  top: 60%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: black;
  font-weight: 500;
}
</style>
